// ═══════════════════════════════════════
// ATLAS BEASTS — LAUNCH CREATURE ROSTER
// Ploonu LLC — Confidential
// ═══════════════════════════════════════

import type { Creature } from '../types'

export const LAUNCH_CREATURES: Creature[] = [
  {
    id: 'rell',
    name: 'Rell',
    species: 'Electric Eel-Wolf',
    element: 'water',
    zone: 'glassdeep',
    rarity: 'surge',
    evolutionStage: 1,
    stats: { attack: 72, defense: 44, speed: 91, bond: 65 },
    moves: [
      { name: 'Arc Bite',      type: 'Contact',  element: 'water', power: 55 },
      { name: 'Current Wrap',  type: 'Control',  element: 'water', power: 70 },
      { name: 'Spine Surge',   type: 'Burst',    element: 'water', power: 95 },
    ],
    bondedCharacterId: 'kai-voss',
    bondLevel: 65,
    condition: 88,
    isTrading: false,
    isSoulbound: false,
    description: 'Chose Kai the night the island sank. Has never explained why. Does not need to.',
  },
  {
    id: 'crag',
    name: 'Crag',
    species: 'Armored Tortoise-Rhino',
    element: 'earth',
    zone: 'rootlands',
    rarity: 'surge',
    evolutionStage: 1,
    stats: { attack: 65, defense: 98, speed: 22, bond: 70 },
    moves: [
      { name: 'Shell Slam',    type: 'Melee',    element: 'earth', power: 60 },
      { name: 'Root Hold',     type: 'Control',  element: 'earth', power: 55 },
      { name: 'Terra Charge',  type: 'Charge',   element: 'earth', power: 90 },
    ],
    bondedCharacterId: 'drego',
    bondLevel: 72,
    condition: 92,
    isTrading: false,
    isSoulbound: false,
    description: 'Ancient creature. Patient as stone. Chose Drego because Drego was the only other thing in the forest that did not need to prove itself.',
  },
  {
    id: 'flick',
    name: 'Flick',
    species: 'Lizard-Bird Scout',
    element: 'air',
    zone: 'skyrift',
    rarity: 'drift',
    evolutionStage: 1,
    stats: { attack: 45, defense: 30, speed: 98, bond: 80 },
    moves: [
      { name: 'Wing Dash',     type: 'Speed',    element: 'air',   power: 40 },
      { name: 'Scout Flash',   type: 'Control',  element: 'air',   power: 50 },
      { name: 'Dive Strike',   type: 'Burst',    element: 'air',   power: 75 },
    ],
    bondedCharacterId: 'reef',
    bondLevel: 88,
    condition: 95,
    isTrading: false,
    isSoulbound: false,
    description: 'Perpetually curious. Scouts 30 seconds ahead of Reef at all times. Has never once been wrong about what is coming.',
  },
  {
    id: 'warden',
    name: 'Warden',
    species: 'Iron Wolf',
    element: 'earth',
    zone: 'rootlands',
    rarity: 'rift',
    evolutionStage: 1,
    stats: { attack: 78, defense: 85, speed: 55, bond: 60 },
    moves: [
      { name: 'Iron Bite',     type: 'Melee',    element: 'earth', power: 68 },
      { name: 'Guard Stance',  type: 'Control',  element: 'earth', power: 0  },
      { name: 'Plate Charge',  type: 'Charge',   element: 'earth', power: 92 },
    ],
    bondedCharacterId: 'marshal-coen',
    bondLevel: 55,
    condition: 78,
    isTrading: false,
    isSoulbound: false,
    description: 'Iron Meridian wanted to weaponize it. Warden chose Coen instead. The institution never forgave either of them.',
  },
  {
    id: 'orrin',
    name: 'Orrin',
    species: 'Deep Jellyfish',
    element: 'water',
    zone: 'glassdeep',
    rarity: 'rift',
    evolutionStage: 1,
    stats: { attack: 40, defense: 65, speed: 48, bond: 95 },
    moves: [
      { name: 'Healing Pulse', type: 'Support',  element: 'water', power: 0  },
      { name: 'Blind Sting',   type: 'Control',  element: 'water', power: 60 },
      { name: 'Deep Bloom',    type: 'Special',  element: 'water', power: 85 },
    ],
    bondedCharacterId: 'lune',
    bondLevel: 90,
    condition: 100,
    isTrading: false,
    isSoulbound: false,
    description: 'Ancient. Peaceful. Has watched civilizations rise and fall from the deep. Chose Lune because her devotion reminded it of something it had not seen in a very long time.',
  },
  {
    id: 'null',
    name: 'NULL',
    species: 'The Formless',
    element: 'void',
    zone: 'null-current',
    rarity: 'apex',
    evolutionStage: 1,
    stats: { attack: 90, defense: 30, speed: 70, bond: 45 },
    moves: [
      { name: 'Void Mirror',   type: 'Control',  element: 'void',  power: 65 },
      { name: 'Fracture Echo', type: 'Burst',    element: 'void',  power: 88 },
      { name: 'The Unnamed',   type: 'Special',  element: 'void',  power: 120 },
    ],
    bondedCharacterId: 'oska-unmade',
    bondLevel: 40,
    condition: 70,
    isTrading: false,
    isSoulbound: false,
    description: 'No fixed form. Mirrors its bonded character\'s emotional state completely. Calm form is small and dim. Enraged form fills rooms. Has been watching Oska for a long time.',
  },
  {
    id: 'mist',
    name: 'Mist',
    species: 'Smoke Fox',
    element: 'air',
    zone: 'skyrift',
    rarity: 'surge',
    evolutionStage: 1,
    stats: { attack: 58, defense: 35, speed: 95, bond: 75 },
    moves: [
      { name: 'Fade',          type: 'Control',  element: 'air',   power: 0  },
      { name: 'Smoke Strike',  type: 'Melee',    element: 'air',   power: 62 },
      { name: 'Ghost Trail',   type: 'Special',  element: 'air',   power: 88 },
    ],
    bondedCharacterId: 'twin-daggers-yara',
    bondLevel: 82,
    condition: 90,
    isTrading: false,
    isSoulbound: false,
    description: 'Made of smoke and loyalty. Never signed anything. Just never left.',
  },
  {
    id: 'scorch',
    name: 'Scorch',
    species: 'Armored Salamander',
    element: 'fire',
    zone: 'ashwake',
    rarity: 'surge',
    evolutionStage: 1,
    stats: { attack: 80, defense: 75, speed: 30, bond: 50 },
    moves: [
      { name: 'Ember Breath',  type: 'Ranged',   element: 'fire',  power: 70 },
      { name: 'Plate Slam',    type: 'Melee',    element: 'fire',  power: 75 },
      { name: 'Magma Core',    type: 'Special',  element: 'fire',  power: 105 },
    ],
    bondedCharacterId: null,
    bondLevel: 0,
    condition: 85,
    isTrading: true,
    isSoulbound: false,
    description: 'Ancient. Never rushes. Does not need to. The Ashwake was built around creatures like Scorch, not the other way around.',
  },
  {
    id: 'origin-founding',
    name: 'ORIGIN',
    species: 'Founding Form',
    element: 'aether',
    zone: 'convergence',
    rarity: 'mythic',
    evolutionStage: 1,
    stats: { attack: 85, defense: 85, speed: 85, bond: 100 },
    moves: [
      { name: 'Convergence',   type: 'Special',  element: 'aether', power: 0  },
      { name: 'First Light',   type: 'Burst',    element: 'aether', power: 100 },
      { name: 'The Origin',    type: 'Special',  element: 'aether', power: 130 },
    ],
    bondedCharacterId: null,
    bondLevel: 0,
    condition: 100,
    isTrading: false,
    isSoulbound: false,
    isFoundingExclusive: true,
    description: 'Carries all elements. Belongs to no zone. Chose the ones who arrived before the world was ready.',
  },
]
